import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/Home/index.vue'),
    meta: {
      title: '量化投研',
      keepAlive: false
    }
  },
  {
    path: '/hot',
    name: 'Hot',
    component: () => import('../views/HotRecom/index.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/divisorRank',
    name: 'divisorRank',
    component: () => import('../views/divisorRank/index.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/clDetail',
    name: 'clDetail',
    component: () => import('../views/tacticsdetail/index.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/clztDetail',
    name: 'clztDetail',
    component: () => import('../views/tacticsdetail/ztcl.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/t0clDetail', // T0策略详情页
    name: 't0clDetail',
    component: () => import('../views/t0/detail.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/create',
    name: 'Create',
    component: () => import('../views/create/index.vue'),
    meta: {
      title: '选择策略',
      keepAlive: false
    }
  },
  {
    path: '/checkedYz',
    name: 'CheckedYz',
    component: () => import('../views/create/checkedYz.vue'),
    meta: {
      title: '选择因子',
      keepAlive: false
    }
  },
  {
    path: '/selectYz',
    name: 'SelectYz',
    component: () => import('../views/create/selectYz.vue'),
    meta: {
      title: '搜索因子',
      keepAlive: false
    }
  },
  {
    path: '/dyzArguments',
    name: 'DyzArguments',
    component: () => import('../views/create/dyzArguments.vue'),
    meta: {
      title: '选择条件',
      keepAlive: false
    }
  },
  {
    path: '/lhArguments',
    name: 'LhArguments',
    component: () => import('../views/create/lhArguments.vue'),
    meta: {
      title: '选择条件',
      keepAlive: false
    }
  },


  // 模拟交易预览
    {
    path: '/arguments',
    name: 'arguments',
    component: () => import('../views/mock/arguments.vue'),
    meta: {
      title: '设置量化条件',
      keepAlive: false
    }
  },



  {
    path: '/dyz-preview', //多因子回测预览
    name: 'Dyz-preview',
    component: () => import('../views/dyz-hc/preview.vue'),
    meta: {
      keepAlive: false
    }
  },

  {
    path: '/dyz-details', //多因子回测详情
    name: 'Dyz-details',
    component: () => import('../views/dyz-hc/details.vue'),
    meta: {
      keepAlive: false
    }
  },

  {
    path: '/lhhc-preview', //量化回测预览
    name: 'Lhhc-preview',
    component: () => import('../views/lh-hc/preview.vue'),
    meta: {
      keepAlive: false
    }
  },

    {
    path: '/mock-preview', //量化回测预览(模拟盘专用)
    name: 'mock-preview',
    component: () => import('../views/mock/preview.vue'),
    meta: {
      keepAlive: false
    }
  },

  {
    path: '/lhhc-details', //量化回测详情
    name: 'Lhhc-details',
    component: () => import('../views/lh-hc/details.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/mnDetail',
    name: 'mnDetail',
    component: () => import('../views/simulatedetail/index.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/my',
    name: 'My',
    component: () => import('../views/my/index.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/report',
    name: 'Report',
    component: () => import('../views/report/index.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/reportSecond', //AI 报告2.0
    name: 'ReportSecond',
    component: () => import('../views/report/second.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/app-preview', //量化回测预览
    name: 'App-preview',
    component: () => import('../views/lh-hc/appPreview.vue'),
    meta: {
      keepAlive: false
    }
  },

  {
    path: '/dtzh-preview', //动态组合预览
    name: 'Dtzh-preview',
    component: () => import('../views/dtzh/preview.vue'),
    meta: {
      keepAlive: false
    }
  },

  {
    path: '/appDetailsNest', //移动端因子详情页 点击回测统计跳转到这个压面
    name: 'AppDetailsNest',
    component: () => import('../views/appDetailsNest/index.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/vipPage', //非vip 广告详情页
    name: 'vipPage',
    component: () => import('../views/vip/vipPage.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/vipPage2', //非vip 广告详情页
    name: 'vipPage2',
    component: () => import('../views/vip/vipPage2.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/hcInfo', // 通过因子进行回测 (客户端单页面)
    name: 'hcInfo',
    component: () => import('../views/factors/hcinfo.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/selectZh', // 搜索组合页
    name: 'selectZh',
    component: () => import('../views/Home/selectzh.vue'),
    meta: {
      keepAlive: false
    }
  },

  {
    path: '/mnjybdMore', // 热门模拟交易榜单-更多
    name: 'MnjybdMore',
    component: () => import('../views/Home/mnjybdMore.vue'),
    meta: {
      keepAlive: false
    }
  },

  {
    path: '/jylzgMore', // 模拟交易领涨股-更多
    name: 'JylzgMore',
    component: () => import('../views/Home/jylzgMore.vue'),
    meta: {
      keepAlive: false
    }
  },

  {
    path: '/clrmgMore', // 策略热门股-更多
    name: 'ClrmgMore',
    component: () => import('../views/Home/clrmgMore.vue'),
    meta: {
      keepAlive: false
    }
  },

  {
    path: '/tcdtMore', // 热门模拟交易调仓动态-更多
    name: 'TcdtMore',
    component: () => import('../views/Home/tcdtMore.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/zdyfactors', // 因子详情页
    name: 'zdyfactors',
    component: () => import('../views/factors/yzinfo.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/zryyFound', // 自然语言创建
    name: 'zryyFound',
    component: () => import('../views/factors/zryyinfo.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/zryypreview', // 自然语言预览
    name: 'zryypreview',
    component: () => import('../views/factors/zryypreview.vue'),
    meta: {
      keepAlive: false
    }
  },
  //
  {
    path: '/qsopen', // 量化实盘多券商签约&实盘登录
    name: 'qsopen',
    component: () => import('../views/qs/index.vue'),
    meta: {
      keepAlive: false
    }
  },
  //
  {
    path: '/qsopentest', // 量化实盘多券商签约&实盘登录
    name: 'qsopen',
    component: () => import('../views/qs/fztest.vue'),
    meta: {
      keepAlive: false
    }
  },

  // 热门避险策略列表(产品1)
  {
    path: '/hedging',
    name: 'hedging',
    component: () => import('../views/hedging/list.vue'),
    meta: {
      keepAlive: false
    }
  },
  // 自选股避险详情(产品1)
  {
    path: '/hedgingDetail',
    name: 'hedging',
    component: () => import('../views/hedging/details.vue'),
    meta: {
      keepAlive: false
    }
  },
  // 持仓股列表
  {
    path: '/postion',
    name: 'postion',
    component: () => import('../views/hedging/postion.vue'),
    meta: {
      title:"添加持仓股",
      keepAlive: false
    }
  }
];

// const originalPush = VueRouter.prototype.push;
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch((err) => err);
// };
const router = new VueRouter({
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0); // 滚动到顶部
  if (to.meta.title) {
    document.title = to.meta.title; // 设置页面标题
  }

  if (to.path == '/report') {
    window.config.isWeb = false;
  }
  next();
});

export default router;
